module.exports = __webpack_public_path__ + "resources/info-filled-2fc272cee53f6e1c6a592a343935cafd.svg";